import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { UUID } from 'angular2-uuid';
import { AgGridNg2 } from 'ag-grid-angular';
import { GlobalsService } from '../services/globals.service';
import { UtilesService } from '../services/utiles.service';
import { UsuarioService } from '../services/usuario.service';
import { VisitaService } from '../services/visita.service';
import { ViajeService } from '../services/viaje.service';
import { VehiculoService } from '../services/vehiculo.service';

import { Usuario } from '../Models/Usuario';
import { Visita } from '../Models/Visita';
import { Viaje } from '../Models/Viaje';
import { Vehiculo } from '../Models/Vehiculo';
import { ViajeVisita } from '../Models/ViajeVisita';

@Component({
  selector: 'app-traslado-mercaderia',
  templateUrl: './traslado-mercaderia.component.html',
  styleUrls: ['./traslado-mercaderia.component.css']
})
export class TrasladoMercaderiaComponent implements OnInit {


  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];

  public visita: Visita = new Visita();
  public visitas: Visita[];

  public viajes: Viaje[];

  public vehiculo: Vehiculo = new Vehiculo();
  public vehiculos: Vehiculo[];

  public rowsSeleccionadas = [];
  public datosSeleccionados: Visita[];

  public viajeVisitas: ViajeVisita[];
  public viajeVisita: ViajeVisita = new ViajeVisita();

  public modoAsignar: boolean = false;
  public modoMostrarVehiculos: boolean = false;


  @ViewChild('agGrid') agGrid: AgGridNg2;

  columnDefs = [
    { headerName: 'Accion', width: 30, checkboxSelection: true, suppressSorting: true, suppressMenu: true, pinned: true, icons: { filter: ' ' } },
    { headerName: 'Código', field: 'idPunto', icons: { filter: ' ' } },
    { headerName: 'Nombre', field: 'nombrePunto', icons: { filter: ' ' } },
    { headerName: 'Dirección', field: 'direccion', icons: { filter: ' ' } },
  ];


  rowData: any[];

  constructor(private usuarioService: UsuarioService, private globalServices: GlobalsService,
    private visitaService: VisitaService, private viajeServise: ViajeService, private vehiculoService: VehiculoService) { }

  ngOnInit() {

    this.visitas = [];
    this.CargarUsuarios();
  }

  /**
   * Carga los usuarios para el combo de usuarios
   */
  CargarUsuarios() {

    try {

      this.usuarioService.ObtenerUsuariosComboBox(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;



        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }

  /**
   * Carga los puntos de vista con el estado de liberar ademas de que el viaje este en esta sincronizado
   */
  CargarPuntosVisitaLiberar() {


    try {

      this.visitaService.ObtenerVisitasLiberar(this.globalServices.ObtenerCompania(), this.usuario.idUsuario).subscribe(
        data => {
          this.visitas = data;
          this.rowData = JSON.parse(JSON.stringify(this.visitas));
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarPuntosVisitaLiberar: " + error);
    }

  }

  /**
   * Selecciona los row que se van a proceder
   * @param event 
   */
  onRowSelected(event) {

    let row = event.node.rowIndex;

    let dataRow = event.data;

    row = this.rowData.findIndex(f => f.idVisita == dataRow.idVisita);

    if (event.node.selected) {
      this.rowsSeleccionadas.push(row);
    }
    else {

      //lo elimina del array
      this.rowsSeleccionadas.splice(row, 1);

    }
  }

  /**
   * Cuando se la click al boton de asignar las visitas 
   */
  AsignarVisitasGrid() {

    let elementos = JSON.parse(JSON.stringify(this.visitas));

    if (this.rowsSeleccionadas === undefined || this, this.rowsSeleccionadas.length == 0) {
      swal("Oops!", "Debe haber registros seleccionados para poder asignarlos", "error");
      return;
    }

    this.datosSeleccionados = [];



    this.rowsSeleccionadas.forEach(element => {

      this.datosSeleccionados.push(this.visitas[element]);

    });

    let filtroDatosSeleccionados = this.datosSeleccionados;
    this.datosSeleccionados = filtroDatosSeleccionados;

    this.rowsSeleccionadas = [];
    this.modoAsignar = true;
    this.usuario = new Usuario();
  }


  /**
   * Se obtiene los viajes que tenga el estado sincronizado
   */
  ObtenerViajesSincronizado() {

    try {

      this.viajeServise.ObtenerViajesSincronizadosUsuario(this.globalServices.ObtenerCompania(), this.usuario.idUsuario).subscribe(
        data => {
          this.viajes = data;

          if (this.viajes.length == 0) {
            this.CargarVehiculos();
            this.modoMostrarVehiculos = true;
          }
          else {
            this.modoMostrarVehiculos = false;
          }

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("AsignarvisitasSeleccionadasGrid: " + error);
    }

  }
  /**
   * Carga los vehiculos para el combo box
   */
  CargarVehiculos() {

    try {

      this.vehiculoService.ObtenerVehiculos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.vehiculos = data;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVehiculos: " + error);
    }
  }

  /**
   * Las visitas seleccionadas son asignadas al destino
   */
  AsignarvisitasDestino() {

    if (this.usuario.idUsuario === undefined) {
      swal("Oops!", "Debe seleccionar el usuario destino", "error");
      return;
    }

    if(this.viajes.length==0){
      if(this.vehiculo.idvehiculo===undefined){
        swal("Oops!", "Debe seleccionar el vehículo", "error");
        return;
      }
    }

   
    this.viajeVisitas = [];
    this.rowsSeleccionadas = [];

    this.datosSeleccionados.forEach(element => {
      
     
      this.viajeVisita.idVisita = element.idVisita;
      this.viajeVisita.estado = 'ACTIVO';
      this.viajeVisita.estadoViajeVisita = "ACTIVO";
      this.viajeVisita.idCompania = element.idCompania;
      this.viajeVisita.idUsuario = this.usuario.idUsuario;
      this.viajeVisita.idVehiculo = this.vehiculo.idvehiculo;
      this.viajeVisita.fechaSincronizacionMovil = null;
      this.viajeVisita.fechaSincronizaacionNube = null;
      this.viajeVisita.fechaInicio = null;
      this.viajeVisita.fechaFinalizacion = null;

      this.viajeVisitas.push(this.viajeVisita);
      this.viajeVisita = new ViajeVisita();
    });

    this.datosSeleccionados = [];

    this.visitaService.GuardarRegistroViajeVisitaTransferirPaquete(this.viajeVisitas).subscribe(

      data => {

        swal("Registro guardado con éxito!", "", "success");

       
        // this.visita = new Visita();
        // this.viajeVisita = new ViajeVisita();
        this.usuario = new Usuario();
        this.vehiculo = new Vehiculo();
        this.datosSeleccionados = [];
        this.rowsSeleccionadas = [];

        this.Cancelar();
      },
      err => {
        
        // this.visita = new Visita();
        // this.viajeVisita = new ViajeVisita();

        this.usuario = new Usuario();
        this.vehiculo = new Vehiculo();
        this.datosSeleccionados = [];
      
        this.rowsSeleccionadas = [];
        this.Cancelar();
       
     
        swal("Oops!", "No podes asignar un viaje a un usuario y trasporte en uso", "error");
        console.log("AsignarvisitasDestino: " + err);


      }

    );


  }

  /**
   * Volver a la pantalla de seleccionar de seleccionar origen
   */
  Cancelar() {

    this.modoAsignar = false;
    this.modoMostrarVehiculos = false;
    this.rowData=[];
  }



  
}
